"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _coreV = require("@stt-componentes/core-v2");
var _moment = _interopRequireDefault(require("moment"));
var _core2 = require("@stt-utilitarios/core");
var _IconeDadosCompletos = _interopRequireDefault(require("./IconeDadosCompletos"));
var _core3 = require("@stt-componentes/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    botaoExibirDetalhes: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    },
    conteudoTitulo: _defineProperty({
      fontWeight: 700,
      fontSize: '17.28px'
    }, theme.breakpoints.down('sm'), {
      fontWeight: 700,
      fontSize: '13px',
      textAlign: 'start'
    }),
    conteudoValor: _defineProperty({
      fontSize: '16px',
      width: '100%'
    }, theme.breakpoints.down('sm'), {
      fontSize: '13px',
      textAlign: 'end'
    }),
    dividerCelular: _defineProperty({
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2)
    }, theme.breakpoints.down('sm'), {
      '&:last-child': {
        display: 'none'
      }
    }),
    gridDados: {
      display: 'grid',
      gridTemplateColumns: '1fr 2fr',
      alignItems: 'center',
      gap: '100px'
    },
    linhasDados: {
      display: 'flex',
      flexDirection: 'column'
    },
    titulo: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
      fontWeight: 700,
      fontSize: '24px'
    }
  };
});
var DetalhesPaciente = function DetalhesPaciente(_ref) {
  var paciente = _ref.paciente,
    strings = _ref.strings;
  var classes = useStyles();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    exibirModal = _useState2[0],
    setExibirModal = _useState2[1];
  var _useState3 = (0, _react.useState)([]),
    _useState4 = _slicedToArray(_useState3, 2),
    dadosPaciente = _useState4[0],
    setDadosPaciente = _useState4[1];
  (0, _react.useEffect)(function () {
    if (paciente) {
      setDadosPaciente([{
        show: true,
        id: 'dados-paciente',
        dados: [paciente.nome && {
          titulo: strings.nome,
          valor: paciente.nome
        }, paciente.genero && {
          titulo: strings.genero,
          valor: paciente.genero.descricao
        }, paciente.raca && {
          titulo: strings.raca,
          valor: paciente.raca.descricao
        }, paciente.dataNascimento && {
          titulo: strings.dataNascimento,
          valor: (0, _moment["default"])(paciente.dataNascimento).format('DD/MM/YYYY')
        }, paciente.idade && {
          titulo: strings.idade,
          valor: paciente.idade
        }, paciente.cpf && {
          titulo: strings.cpf,
          valor: _core2.Util.util.adicionarMascara(('00000000000' + (paciente.cpf + '').replace(/\D/g, '')).slice(-11), '000.000.000-00')
        }, paciente.cns && {
          titulo: strings.cns,
          valor: _core2.Util.util.adicionarMascara((paciente.cns + '').replace(/\D/g, ''), '000 0000 0000 0000')
        }, paciente.nomeMae && {
          titulo: strings.nomeMae,
          valor: paciente.nomeMae
        }, paciente.peso && {
          titulo: strings.peso,
          valor: paciente.peso
        }, paciente.altura && {
          titulo: strings.altura,
          valor: paciente.altura
        }, paciente.cep && {
          titulo: strings.cep,
          valor: _core2.Util.util.adicionarMascara((paciente.cep + '').replace(/\D/g, ''), '00000-000')
        }, paciente.logradouro && {
          titulo: strings.logradouro,
          valor: paciente.logradouro
        }, paciente.numero && {
          titulo: strings.numero,
          valor: paciente.numero
        }, paciente.bairro && {
          titulo: strings.bairro,
          valor: paciente.bairro
        }, paciente.cidade && {
          titulo: strings.cidadeUf,
          valor: "".concat(paciente.cidade, "/").concat(paciente.estado)
        }, paciente.contato1 && {
          titulo: strings.telefoneFixo,
          valor: _core2.Util.util.adicionarMascara((paciente.contato1 + '').replace(/\D/g, ''), '(00) 0000-0000')
        }, paciente.contato2 && {
          titulo: strings.telefoneCelular,
          valor: _core2.Util.util.adicionarMascara((paciente.contato2 + '').replace(/\D/g, ''), '(00) 00000-0000')
        }, paciente.email && {
          titulo: strings.email,
          valor: paciente.email
        }]
      }]);
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_coreV.SttButton, {
    type: "button",
    variant: "outlined",
    color: "secondary",
    nomarginleft: "true",
    className: classes.botaoExibirDetalhes,
    onClick: function onClick() {
      return setExibirModal(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_IconeDadosCompletos["default"], {
    style: {
      marginRight: '4px'
    }
  }), (strings === null || strings === void 0 ? void 0 : strings.abrirDadosCompletosPaciente) || 'Abrir dados completos'), /*#__PURE__*/_react["default"].createElement(_coreV.SttModal, {
    title: strings.dadosCompletosPaciente || 'Dados completos do Paciente',
    open: exibirModal,
    maxWidth: "md",
    outModalClose: function outModalClose() {
      return setExibirModal(false);
    },
    iconClose: function iconClose() {
      return setExibirModal(false);
    },
    fullWidth: true,
    children: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, dadosPaciente.map(function (item, index) {
      if (!item.id) {
        item.id = item.titulo;
      }
      return /*#__PURE__*/_react["default"].createElement("section", {
        key: item.id,
        id: item.id,
        tabIndex: -1,
        style: {
          marginTop: index < dadosPaciente.length - 1 ? 12 : 0,
          marginBottom: index < dadosPaciente.length - 1 ? 12 : 0
        }
      }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
        variant: "h3",
        color: "primary",
        className: classes.titulo
      }, item.titulo), /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.linhasDados
      }, item.dados.filter(Boolean).map(function (dado, idx, array) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: idx
        }, dado.titulo ? /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.gridDados
        }, /*#__PURE__*/_react["default"].createElement(_coreV.SttText, {
          className: classes.conteudoTitulo
        }, dado.titulo), /*#__PURE__*/_react["default"].createElement(_coreV.SttText, {
          className: classes.conteudoValor
        }, dado.valor)) : /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            textAlign: 'start'
          }
        }, dado.valor), idx < array.length - 1 && /*#__PURE__*/_react["default"].createElement(_core3.SttDivider, {
          style: {
            marginTop: 4,
            marginBottom: 4
          }
        }));
      })), index < dadosPaciente.length - 1 && /*#__PURE__*/_react["default"].createElement(_core3.SttDivider, {
        className: classes.dividerCelular
      }));
    }))
  }));
};
var _default = exports["default"] = DetalhesPaciente;